/* eslint-disable max-len */
import { DownOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type SimpleVehicleManagementModuleSpecsFragment } from '../../../../api/fragments/SimpleVehicleManagementModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

export type SimpleVehicleManagementModuleActionsProps = {
    module: SimpleVehicleManagementModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const SimpleVehicleManagementModuleActions = ({ module, permissions }: SimpleVehicleManagementModuleActionsProps) => {
    const { t } = useTranslation(['simpleVehicleManagementDetail', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = useMemo(
        () =>
            [
                hasDeletePermission && {
                    label: t('simpleVehicleManagementDetail:mainActionButtons.delete'),
                    key: 'delete',
                    icon: <DeleteOutlined />,
                    onClick: deleteModule,
                    danger: true,
                },
            ].filter(Boolean),
        [deleteModule, hasDeletePermission, t]
    );

    if (!items.length) {
        return null;
    }

    return (
        <Dropdown overlay={<Menu items={items} />}>
            <Button type="primary">
                <Space>
                    <span>{t('simpleVehicleManagementDetail:mainActionButtons.actions')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default SimpleVehicleManagementModuleActions;
